export interface LoginRequest {
	email: string;
	password: string;
}

export interface PasswordResetRequest {
	email: string;
}

export interface PasswordResetCancelRequest {
	code: string;
}

export interface PasswordChangeRequest {
	email: string;
	resetCode: string;
	newPassword: string;
}

export interface LoginResultTenant {
	id: string
	userId: string
	title: string
	disabled: boolean
}

export interface LoginResult {
	loginTenants: LoginResultTenant[] | null
	requiresMfa: boolean
	requiresMfaSetup?: boolean
	systemAdmin?: boolean
	supportAccess: LoginResultTenant | null
	requiresIntroduction?: boolean
}

export interface CurrentLogin {
	allowSystemAdmin: boolean
	requiresMfaSetup: boolean
	requiresIntroduction?: boolean

	supportAccess: LoginResultTenant | null
}

export enum LoginState {
	NotLoggedIn,
	PendingTenantSelect,
	PendingMfa,
	LoggedIn,
	PendingMfaSetup,
	PendingSystemMfa,
	PendingSystemMfaSetup,
	Introduction,
	Waiting
}
